module.exports = __webpack_public_path__ + "static/img/p2r.be3541b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2r.png
// module id = UcKo
// module chunks = 73